import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useObserver } from "mobx-react-lite";
import { autorun } from "mobx";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { useStore } from "Store";
import * as S from "./../styles";
import Grid from "@material-ui/core/Grid";

// @ts-ignore
import { FormikTextField } from "formik-material-fields";

import LoadingModal from "Components/LoadingModal";

const override = css`
  margin: 0 auto;
  padding: 0;
`;

const RecoveryPass: React.FC = () => {
  const history = useHistory();
  const { userStore, appStore, subscriptionsStore } = useStore();

  useEffect(() => {
    appStore.initializeBaseURL();
  }, []);

  useEffect(
    () =>
      autorun(() => {
        if (userStore.isSignedIn) {
          history.push("/");
        }
      }),
    [userStore, userStore.isSignedIn, history]
  );

  const onHandleSubmit = async (values: any, rest: any) => {
    try {
      const response = await userStore.validateResetToken(values.email, values.code);

      if (response) {
        const resp = await userStore.recoveryPassword(values.password, values.code);
        if (resp) {
            history.push("/signin")
        }
      }
    } catch (error) {
      rest.setSubmitting(false);
      console.log(error);
    }
  };

  const RecoveryPassSchema = Yup.object().shape({
    username: Yup.string().required("Por favor, insira seu nome de usuário"),
    password: Yup.string().required("Por favor, insira sua senha"),
  });
  const RecoveryPassInicialValues = {
    code: "",
    email: "",
    password: ""
  };

  return useObserver(() => (
    <S.Container>
      <LoadingModal open={userStore.isSigninInUnderTheHood}>
        <S.LoadingStatusContainer>
          Gerando email para envio...
        </S.LoadingStatusContainer>
      </LoadingModal>
      <S.LogoContainer />
      <S.ContentContainer>
        <Formik
          onSubmit={onHandleSubmit}
          initialValues={RecoveryPassInicialValues}
        >
          {({ isSubmitting, isValid }) => (
            <Form>
              <Grid container spacing={2}>
                <S.FormContainer>
                  <S.FormSubtitle>
                    Digite o código de validação e sua nova senha para confirmar.
                  </S.FormSubtitle>
                  <FormikTextField
                    name="code"
                    label="Código de validação"
                    fullWidth
                    variant="outlined"
                  />
                  <FormikTextField
                    name="email"
                    label="Email"
                    fullWidth
                    variant="outlined"
                  />
                  <FormikTextField
                    name="password"
                    label="Nova Senha"
                    type="password"
                    fullWidth
                    variant="outlined"
                  />
                  <S.LoginButton
                    type="submit"
                    disabled={!isValid || isSubmitting}
                  >
                    <S.LoginButtonTitle>
                      {isSubmitting ? (
                        <ClipLoader
                          css={override}
                          size={14}
                          color={"#fff"}
                          loading={true}
                        />
                      ) : (
                        "Enviar"
                      )}
                    </S.LoginButtonTitle>
                  </S.LoginButton>
                </S.FormContainer>
              </Grid>
            </Form>
          )}
        </Formik>
      </S.ContentContainer>
    </S.Container>
  ));
};

export default RecoveryPass;
